import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "key-description bg-yellow-100 border border-yellow-300 text-yellow-700 px-4 py-3 rounded relative"
}
const _hoisted_2 = { class: "block sm:inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode("To get an answer from GPT you need to setup an API Key in "),
          _createVNode(_component_router_link, {
            to: "/settings",
            class: "font-bold underline ml-1 sm:ml-0"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Settings")
            ]),
            _: 1
          }),
          _createTextVNode(" and change the mode to 'client'")
        ])
      ]))
    : _createCommentVNode("", true)
}